<script lang="ts">
    export let loading = true;
</script>

{#if loading}
    <div class="max-w-4xl mx-auto p-6 animate-pulse" data-testid="blog-detail-skeleton">

        <!-- Back button + header -->
        <div class="flex items-center gap-3 mb-8">
            <div class="w-8 h-8 bg-gray-300 rounded"></div>
            <div class="h-6 w-40 bg-gray-300 rounded"></div>
        </div>

        <!-- Title -->
        <div class="h-12 bg-gray-300 rounded mb-8 w-3/4"></div>

        <!-- Author + Date -->
        <div class="flex items-center gap-2 mb-4">
            <div class="h-4 w-20 bg-gray-300 rounded"></div>
            <div class="h-4 w-1 bg-gray-300 rounded"></div>
            <div class="h-4 w-24 bg-gray-300 rounded"></div>
        </div>

        <!-- Image -->
        <div class="w-full h-64 bg-gray-300 rounded mb-6"></div>

        <!-- Content lines -->
        <div class="space-y-3">
            <div class="h-4 bg-gray-300 rounded w-full"></div>
            <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            <div class="h-4 bg-gray-300 rounded w-4/6"></div>
            <div class="h-4 bg-gray-300 rounded w-3/4"></div>
            <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            <div class="h-4 bg-gray-300 rounded w-2/3"></div>
        </div>

    </div>
{/if}
